import { render } from "./ModioApp.vue?vue&type=template&id=9ce3d7b4"
import script from "./ModioApp.vue?vue&type=script&lang=js"
export * from "./ModioApp.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__